module.exports = __webpack_public_path__ + "static/media/bio.407da91c.png";